export enum ImportConnectionTypeOption {
    Afas = 1,
    Azure = 2,
    Off = 0
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/instance/models/import-connectiontype-option.ts